/**
 * Convert vue-i18n locale code (e.g. 'pt_BR') to BCP-47 tag (e.g. 'pt-BR')
 * used by Intl.DateTimeFormat / toLocaleDateString.
 * Falls back to 'en' when the locale is missing or invalid.
 */
export const getDateLocale = i18nLocale => {
  if (!i18nLocale) return 'en';
  return i18nLocale.replace('_', '-');
};

export const formatTime = seconds => {
  if (!seconds) return '0s';
  const s = Math.floor(seconds % 60);
  const totalMin = Math.floor(seconds / 60);
  const m = totalMin % 60;
  const totalHrs = Math.floor(totalMin / 60);
  const h = totalHrs % 24;
  const d = Math.floor(totalHrs / 24);

  if (d > 0) return `${d}d ${h}h`;
  if (h > 0) return `${h}h ${m}m`;
  if (totalMin > 0) return `${totalMin}m ${s}s`;
  return `${s}s`;
};

export const formatTrend = value => {
  if (!value || value === 0) return '0%';
  const sign = value > 0 ? '+' : '';
  return `${sign}${value}%`;
};

export const trendLabel = (value, suffix = '') => {
  if (!value || value === 0) return '';
  const sign = value > 0 ? '+' : '';
  return `${sign}${value}${suffix}`;
};
